import React from 'react';
import SqftStore from "../../../canvas/store/sqftStore";
import SvgIcon from "@mui/material/SvgIcon";
import {ScreenshotIcon} from "../../../../../common/icons";
import COLOR_THEMES from "../../../../../../colorThemes";
import {FormattedMessage, injectIntl} from "react-intl";
import Button from "@mui/material/Button";
import {changeSqftFeaturesPopup, setAPIErrorMessage, setSqftCabinetsGlb} from "../../../../../../actions/sqftFunctions";
import {setSQFTAr3dPopup} from "../../../../../../actions/sqftMenuFunctions";
import {connect} from "react-redux";
import workspaceControllers from "../../../canvas/store/workspaceControllers";

const ScreenshotButton = (props) => {
  const {activeTheme, isMobile} = props;

  const saveScreenshot = () => {
    const viewGL = SqftStore.viewGL;

    if (viewGL && viewGL.renderer && viewGL.scene && viewGL.camera) {
      // Force render
      viewGL.renderer.render(viewGL.scene, viewGL.camera);

      const canvas = viewGL.renderer.domElement;

      try {
        // Get data URL directly
        const dataURL = canvas.toDataURL('image/png');

        // Check if image is not empty
        if (dataURL === 'data:,') {
          console.error('Canvas is empty');
          return;
        }

        // Download
        const link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.href = dataURL;
        link.download = '3Dscreenshot.png';
        link.click();

        // Cleanup
        setTimeout(() => {
          document.body.removeChild(link);
        }, 100);

        // Convert to blob for saving
        fetch(dataURL)
          .then(res => res.blob())
          .then(blob => {
            workspaceControllers.images3d.saveBlobAsScreenshot(blob);
          })
          .catch(error => {
            console.error('Error converting to blob:', error);
          });
      } catch (error) {
        console.error('Error creating screenshot:', error);
      }
    } else {
      console.error('Renderer, scene or camera not found');
    }
  };
  const screenshotIconStyle = isMobile ? { marginLeft: "13px", marginTop: "7px"} : { marginLeft: "5px", marginTop: "5px"}

  return (
    <Button className={"ui-button2 ui-button2--medium ui-button2--primary-border"}
            style={{backgroundColor: "white"}}
            startIcon={(
              <SvgIcon style={screenshotIconStyle} >
                <ScreenshotIcon color={COLOR_THEMES[activeTheme].primary} />
              </SvgIcon>
            )}
            onClick={() => saveScreenshot()}>
      {
        isMobile ? "" : <FormattedMessage id="sqft.popup.button.save3dImage"/>
      }
    </Button>
  );
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  return {
    isMobile,
    activeTheme: store.serverState.activeTheme,
  };
};
const mapDispatchToProps = {
  setSqftCabinetsGlb,
  setSQFTAr3dPopup,
  changeSqftFeaturesPopup,
  setAPIErrorMessage,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ScreenshotButton)
)

